import { RelaySDK } from '@fiverr-private/relay-sdk/dist/legacy';
import { getTraceId } from '../../../../helpers/getTraceId';

/**
 * Send data using Relay SDK
 * @param  {Object} data
 * @return {boolean}
 */
export default function logRemotely({ host }) {
    /**
     * Backward compatibility with older OBS version for "host": Old URL
     * TODO: Remove this in the next major version (2.0.0)
     */
    host = /\/v\d\//.test(host) ? new URL(host).origin : host;
    const relaySDK = new RelaySDK({
        id: getTraceId(),
        endpoint: `${host}/v3/relay`
    });

    function log(data) {
        return relaySDK.log(data);
    }

    /**
     * Enrichment allows you to add additional data to all logs
     * @param {() => import('@fiverr-private/relay-sdk').Context} enricher
     * @returns {self} Use an anonymous/named function and return self
     */
    log.setEnricher = function setEnricher(enricher) {
        relaySDK.registerContext('log', enricher());
        return this;
    };
    return log;
}
